// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"226":"6b4e048aca314cfc1dc9","540":"15a05daff105a0cf47e1","579":"bf86f4d0e08b3486cfa3","961":"ce71157ec6c5b89005f3"}[chunkId] + ".js";
};